import { createSlice } from "@reduxjs/toolkit";

export const templatesSlice = createSlice({
  name: "templates",
  initialState: {
    getTemplatesResult: false,
    getTemplatesLoading: false,
    getTemplatesError: false,
    addTemplatesResult: false,
    addTemplatesLoading: false,
    deleteTemplatesResult: false,
  },
  reducers: {
    templatesReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TEMPLATES":
          return {
            ...state,
            getTemplatesResult: payload.data,
            getTemplatesLoading: payload.loading,
            getTemplatesError: payload.error,
          };
        case "ADD_TEMPLATES":
          return {
            ...state,
            addTemplatesResult: payload.data,
            addTemplatesLoading: payload.loading,
          };
        case "DELETE_TEMPLATES":
          return {
            ...state,
            deleteTemplatesResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { templatesReducers } = templatesSlice.actions;

export default templatesSlice.reducer;
